import { Component, EventEmitter, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { PlatformService } from '@panamax/app-state';
import { ModalWithNavComponent } from '@shared/components/modal-with-nav/modal-with-nav.component';
import { ModalService } from '@shared/services/modal/modal.service';
import { InviteUserModalComponent } from '../../../shared/components/invite-user-modal/invite-user-modal.component';

@Component({
  selector: 'app-profile-invite-new-user-card',
  templateUrl: './invite-new-user-card.component.html',
  styleUrls: ['./invite-new-user-card.component.scss'],
})
export class InviteNewUserCardComponent {
  constructor(
    private modalService: ModalService,
    protected modalController: ModalController,
    readonly platformService: PlatformService,
    protected translateService: TranslateService,
  ) {}

  async openInviteNewUserModal() {
    this.modalService.setModalOptions(
      this.platformService.platformType !==
        this.platformService.platformEnum.desktop,
      ModalWithNavComponent,
      {
        rootPage: InviteUserModalComponent,
      },
      'invite-new-user-modal',
    );
    const modal = await this.modalController.create(
      this.modalService.modalOptions,
    );
    return await modal.present();
  }
}
